// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Form as FinalForm, Field } from 'react-final-form';
import cn from 'classnames';
// Components
import Spinner from '../../components/Spinner';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class Radio extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    if (this.props.reseteble && this.props.checked) {
      this.unChecking = true;
      this.props.onChange(
        typeof this.props.resetTo !== 'undefined' ? String(this.props.resetTo) : '',
      );
    }
  };

  onChange = e => {
    if (this.props.onChange && !this.unChecking) {
      this.props.onChange(e);
    }
    this.unChecking = false;
    this.props.handleChange && this.props.handleChange(e);
  };

  render() {
    const {
      checked,
      light,
      row,
      type,
      tile,
      text,
      icon,
      loading,
      disabled,
      className,
      onChange,
      reseteble,
      ...otherProps
    } = this.props;

    const blockWrapperClass = cn({
      Radio: true,
      Radio_row: row,
      Radio_tile: tile,
      Radio_type: type,
      Radio_disabled: disabled,
      [`${className}`]: className,
    });
    const blockContentClass = cn({
      Radio__content: true,
      Radio__content_tile: tile,
      Radio__content_type: type,
      Radio__content_row: row,
      Radio__content_light: light,
      [`Radio__content_${type}`]: type,
    });
    const blockTextClass = cn({
      Radio__text: true,
      Radio__text_loading: loading,
    });

    return (
      <label className={blockWrapperClass} onClick={this.handleClick}>
        <input
          {...otherProps}
          type="radio"
          onChange={this.onChange}
          disabled={disabled}
          checked={checked}
        />
        <div className={blockContentClass}>
          <span className={blockTextClass}>{text}</span>
          {loading && (
            <span className="Radio__spinner">
              <Spinner size={30} currentColor />
            </span>
          )}
        </div>
        {icon && <img src={icon} className="Radio__icon" />}
      </label>
    );
  }
}

Radio.defaultProps = {
  className: '',
  input: {},
  name: '',
  light: false,
  row: false,
  type: false,
  tile: false,
  icon: null,
  reseteble: false,
  disabled: false,
};

Radio.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  name: PropTypes.string,
  light: PropTypes.bool,
  row: PropTypes.bool,
  type: PropTypes.bool,
  tile: PropTypes.bool,
  icon: PropTypes.string,
  reseteble: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Radio;



// WEBPACK FOOTER //
// components/Radio/index.js